import { Component } from 'react';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    //console.log('>>>>>>>>>', error);
    return { hasError: true };
  }

  render() {
    if (this.state.hasError)
      return (
        <div style={{position: 'relative', paddingTop: '45%', paddingLeft: '5%', color: 'red', fontWeight: '900'}}>
        동영상을 재생할 수 없습니다.<br/>다시 시도해주세요.  
        </div>
      );
    return this.props.children;
  }
}
export default function ErrorComponent({ children }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}
